import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

const CustomerLayout = () => {
  return <Container>
    <Outlet />
  </Container>;
};

export default CustomerLayout;
const Container = styled.div`
  flex: 1;
`;